export const withLogic =
  (Component: React.ComponentType<any>): React.FC<any> =>
  (props: any) => {
    const { prefix, ...rest } = props;
    return (
      <Component
        {...{
          ...rest,
          onSuffixClick: () => {
            rest.onSuffixClick?.(rest.internalIndex);
          }
        }}
      />
    );
  };
